import { RootState } from '@/App/store';

export const selectUserEditOpen = (state: RootState) => state.user.editOpen;
